import { PROJECT_USER_SUCCESS, EDIT_PROJECT_USER, RESET_PROJECT_USER,SET_CURRENT_PROJECT, UNSET_CURRENT_PROJECT } from "./actionTypes";

const initialState = {
  error: "",
  success: "",
  projectUser: undefined,
  currentProject: null
};

const projectUser = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROJECT_USER:
      state = { ...state };
      break;
    case PROJECT_USER_SUCCESS:
      state = {
        ...state,
        success: action.payload.status,
        projectUser: action.payload.data,
        loading: false
      };
      break;
    // case PROFILE_ERROR:
    //   state = {
    //     ...state,
    //     error: action.payload,
    //     loading: false
    //   };
    //   break;
    case RESET_PROJECT_USER:
      state = {
        ...state,
        success: null
      };
      break;
    case SET_CURRENT_PROJECT:
      state = {
        ...state,
        currentProject: action.payload
      };
      break;
    case UNSET_CURRENT_PROJECT:
      state = {
        ...state,
        currentProject: null
      };
      break;      
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default projectUser;
